import { render, staticRenderFns } from "./TabsProvider.vue?vue&type=template&id=65a663d2&scoped=true&"
import script from "./TabsProvider.vue?vue&type=script&lang=js&"
export * from "./TabsProvider.vue?vue&type=script&lang=js&"
import style0 from "./TabsProvider.vue?vue&type=style&index=0&id=65a663d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a663d2",
  null
  
)

export default component.exports